/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import _ from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
// import custom Component
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import { TableHeaderForCMSRosiDetail } from './gridComponents/tableHead';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  checkActionAccessByRole,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import {
  getNDCDetails,
  setNDCErrorPopupMessage,
  setNDCDetails,
  setCurrentNDCDetailsIndex,
  setCurrentNDCDetailsSelected,
} from '../../../Display/NDC/store/action';
import {
  getCmsRosiByCriteria,
  handleErrorMessages,
  getExistingCorrLinkIds,
  updateAuditClearedIndex,
  handleSuccessMessages,
  dispatchSaveUpdate,
  dispatchUpdateAuditClearedIndex,
} from '../store/Actions';
import { NO_DATA_FOUND, LOADING, CMS_ROS_DISCREPANCY } from './ConstData';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  redirectURLLink,
  closeTab,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import { convertQuarter } from '../../../../SharedModules/DateUtilities/DateUtilities';

const CmsRosiDetails = ({ location }) => {
  const history = useHistory();
  const { isReadOnly } = location;
  const dispatch = useDispatch();
  // States with initial values
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [corrLinkId, setCorrLinkId] = useState(null);
  const [linkTableName, setLinkTableName] = React.useState('DRUG_AUDIT');
  const [showComments, setShowComments] = useState(false);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [keyValue, setKeyValue] = useState([]);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState();
  const [cancelView, setCancelView] = React.useState(false);
  const [saveView, setSaveView] = React.useState(false);
  const [tData, setTableData] = React.useState();
  const [loading, setLoading] = useState(false);

  // Use Selector
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const [hasAccessbyRole, setHasAccessbyRole] = useState(
    checkActionAccessByRole(
      process.env.REACT_APP_HIDE_RESEARCH_CMS_ROLES,
      kcRoles
    )
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const detailspagetable = useSelector(
    (state) =>
      state.sharedState.CMSRosiReducer.searchInvoiceByCriteriaList
        .cmsRosiResponse
  );
  const disableSaveCancel = useSelector(
    (state) => state.sharedState.CMSRosiReducer?.saveUpdateState
  );
  const auditClearedIndexData = useSelector(
    (state) => state.sharedState.CMSRosiReducer.auditClearedIndexData
  );
  const searchCmsRosiObj = useSelector(
    (state) => state.sharedState.CMSRosiReducer.searchCmsRosiObj
  );
  const errorMessagesFromRedux = useSelector(
    (state) => state.sharedState.CMSRosiReducer.errorMessagesInRedux
  );
  const fetchState = useSelector(
    (state) => state.sharedState.CMSRosiReducer?.searchCmsRosiObj?.state
  );
  const successMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.CMSRosiReducer?.successMessageInRedux;
  });
  const searchCmsRosiByCriteriaList = useSelector((state) => {
    return state.sharedState.CMSRosiReducer.searchCmsRosiByCriteriaList;
  });
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  // Save CMS ROSI Discrepancies
  const saveClearedAuditData = (value) => {
    setLoading(true);
    setClickOncloseTabBtn(value);
    const newObj = detailspagetable?.map((item) => {
      const obj = {
        drugAuditId: {
          drugSeqNum: item.drugSeqNum,
          rebateProgramCd: item.rebateProgramCode,
          qtr: item.qurater,
          auditTypeCd: item.discrepancyType,
        },
        auditClearedInd: item.discrepancyCleared,
        lastUpdateUserId: logInUser,
      };
      return obj;
    });
    dispatch(updateAuditClearedIndex(newObj));
    handleExistingCommentList(detailspagetable);
    setSaveView(false);
    dispatch(dispatchSaveUpdate(true));
  };
  // set comment icon on if corrLinkId and comment is available
  const handleExistingCommentList = (detailspagetable) => {
    if (detailspagetable && detailspagetable.length > 0) {
      getExistingCorrLinkIds({
        corrLinkId: detailspagetable.map((item) => {
          return item.corrLinkId;
        }),
      }).then((result) => {
        const tempObj =
          detailspagetable &&
          detailspagetable.map((item) => {
            if (
              result &&
              result.data?.length > 0 &&
              result.data?.filter((x) => {
                return x === item.corrLinkId;
              }).length > 0
            ) {
              item.ccCommentsExist = 1;
            } else {
              item.ccCommentsExist = 0;
            }
            return item;
          });
        setTableData(tempObj);
      });
    } else if (detailspagetable && detailspagetable.length === 0) {
      setTableData(detailspagetable);
    }
  };

  // clear error message
  React.useEffect(() => {
    setLoading(false);
    dispatch(dispatchSaveUpdate(true));
    handleScrollToEvent();
    setErrorMessages([]);
  }, []);

  // for disable save cancel update
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (detailspagetable && Object.keys(detailspagetable).length > 0) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/cmsRosiDetails' && !disableSaveCancel) {
            item.isFormDirty = true;
            dispatch(dispatchSaveUpdate(false));
          } else if (item.navTo === '/cmsRosiDetails') item.isFormDirty = false;
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [!disableSaveCancel || detailspagetable]);

  // handle close and confirm popup
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/cmsRosiDetails' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/cmsRosiDetails' && item.isFormSave) {
          item.isFormSave = false;
          saveClearedAuditData(true);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  // handing highlight tab
  React.useEffect(() => {
    if (
      errorMessagesFromRedux?.detailScreenErrors &&
      errorMessagesFromRedux?.detailScreenErrors.length > 0
    ) {
      tabHighLigther('/cmsRosiDetails', true);
    } else {
      tabHighLigther('/cmsRosiDetails', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);

  // set Initial state values
  React.useEffect(() => {
    handleScrollToEvent();
    if (searchCmsRosiObj) {
      setClickOncloseTabBtn(true);
      setTableData();
      handleExistingCommentList(detailspagetable);
    }
  }, [detailspagetable, showComments]);

  // handle after call service show success and error message
  React.useEffect(() => {
    setLoading(false);
    if (auditClearedIndexData && auditClearedIndexData.message === 'Success') {
      dispatch(dispatchSaveUpdate(true));
      setSaveView(false);
      setErrorMessages([]);
      dispatch(getCmsRosiByCriteria(searchCmsRosiByCriteriaList));
      dispatch(
        handleSuccessMessages([constantMessageData.SUCCESSMESSAGE_GENERIC])
      );
      if (clickOncloseTabBtn) {
        dispatch(handleSuccessMessages([]));
        closeTab('/cmsRosiDetails', history);
      }
      dispatch(dispatchUpdateAuditClearedIndex({}));
    } else if (auditClearedIndexData === 'failed') {
      dispatch(dispatchSaveUpdate(true));
      setSaveView(false);
      dispatch(
        handleErrorMessages({
          detailScreenErrors: [
            ...new Set([constantMessageData.FAILED_MESSAGE_GENERIC]),
          ],
          searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
            ? errorMessagesFromRedux?.searchScreenErrors
            : [],
        })
      );

      handleScrollToEvent();
    }
  }, [auditClearedIndexData]);

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // Refresh selected cells
  const cellValueUpdateCustom = React.useCallback((params) => {
    if (params?.api) {
      params.api.refreshCells({ force: params.data });
    }
  }, []);

  // handing view History popup
  const handleViewHistory = (api) => {
    const selectedRow = api.getSelectedRows()?.[0];
    const convertedQtr = convertQuarter(selectedRow.qurater);
    setShowViewHistory(true);
    const temp = {
      DRUG_SEQ_NUM: selectedRow.drugSeqNum,
      REBATE_PROGRAM_CD: selectedRow.rebateProgramCode,
      QTR: convertedQtr,
      AUDIT_TYPE_CD: fetchState.auditTypeCd,
    };
    setKeyValue(
      linkTableName === 'DRUG_AUDIT' && fetchState?.allAuditTypes !== true
        ? { ...temp, AUDIT_TYPE_CD: fetchState?.selectedAuditType }
        : temp
    );
  };

  // Handle Onchange for checkboxes
  const handleOnChangeEvent = (event, name) => {
    const clearIndex =
      name === 'unclearedIndex' && !event && !fetchState?.clearedIndex
        ? 1
        : name === 'clearedIndex' && !event
        ? false
        : (name === 'clearedIndex' && event) || fetchState?.clearedIndex
        ? true
        : false;
    const unClearIndex =
      name === 'clearedIndex' && !event && !fetchState?.unclearedIndex
        ? 1
        : name === 'unclearedIndex' && !event
        ? false
        : (name === 'unclearedIndex' && event) || fetchState.unclearedIndex
        ? true
        : false;
    dispatch(
      getCmsRosiByCriteria({
        ...searchCmsRosiByCriteriaList,
        clearedIndex:
          clearIndex && unClearIndex ? 1 : clearIndex && !unClearIndex ? 1 : 0,
        unclearedIndex:
          clearIndex && unClearIndex ? 0 : clearIndex && !unClearIndex ? 1 : 0,
      })
    );
    fetchState.clearedIndex = clearIndex;
    fetchState.unclearedIndex = unClearIndex;
  };

  // Cancel cleared Audit data
  const cancelClearedAuditData = () => {
    dispatch(getCmsRosiByCriteria(searchCmsRosiByCriteriaList));
    setCancelView(false);
    dispatch(dispatchSaveUpdate(true));
  };

  return (
    <div
      className='tBillPanel custom-check tabs-container'
      data-testid='cms-rosi-detail'
    >
      <CustomSeparator parent1='CMS ROSI' parent2='CMS ROSI Detail' />
      {!fullScreenView && (
        <>
          <DisplaySuccessMessages successMessages={successMessagesFromRedux} />
          <DisplayErrorMessages
            errorMessages={
              errorMessages && errorMessages.length > 0
                ? [...new Set(errorMessages)]
                : errorMessagesFromRedux?.detailScreenErrors?.length > 0
                ? _.map(
                    errorMessagesFromRedux.detailScreenErrors,
                    (l) => l.message
                  )
                : []
            }
          />
          <Spinner load={spinnerLoader} />
        </>
      )}
      <SaveCancelPopup
        open={cancelView}
        title='Cancel'
        data-test='reset-button-uc'
        onConfim={cancelClearedAuditData}
        onCancel={(e) => setCancelView(false)}
        moduleName=''
      />
      <SaveCancelPopup
        open={saveView}
        title='Save'
        data-testid='save-api-uc'
        onConfim={() => saveClearedAuditData(false)}
        onCancel={(e) => setSaveView(false)}
        moduleName=''
      />
      <div className='row position-relative'>
        <div className='col-12'>
          <div className='btn-wrapper mb-2 float-right'>
            <div className='float-right mt-2 hide-on-print'>
              <Button
                className='btn btn-success btn-search'
                data-testid='save-minor'
                onClick={() => setSaveView(true)}
                disabled={disableSaveCancel || isReadOnly || !hasAccessbyRole}
              >
                <SVGComponent iconName='Icon-awesome-save' /> Save
              </Button>
              <Button
                className='btn btn-cancel'
                data-testid='cancel-minor'
                onClick={() => setCancelView(true)}
                disabled={disableSaveCancel || isReadOnly || !hasAccessbyRole}
              >
                <SVGComponent iconName='Icon-cancel' /> Cancel
              </Button>
            </div>
            <div className='clearfix' />
          </div>
        </div>
        <div className='col-sm-12 FRR-custom-table tbl-manufacturer-inner frr-log_chk'>
          <TableGrid
            data-testid='cms-mismatch-details-component-grid'
            rowSelection='multiple'
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            isScrollOn
            onCellFocused={onCellFocused}
            columnDefs={TableHeaderForCMSRosiDetail}
            rowData={tData}
            handleViewHistory={handleViewHistory}
            exportFile
            overlayNoRowsTemplate={
              !tData ? LOADING : tData?.length == 0 ? NO_DATA_FOUND : ''
            }
            fileName={CMS_ROS_DISCREPANCY}
            animateRows
            onCellValueChanged={(e) => cellValueUpdateCustom(e)}
            sideBar={false}
            frameworkComponents={{
              ActionCellRender: (cellInfo) => {
                let name = '';
                if (cellInfo?.colDef?.headerName === 'NDC') {
                  name = cellInfo.data.ndc;
                }
                if (cellInfo?.colDef?.headerName === 'Drug Name') {
                  name = cellInfo.data.drugName;
                }
                // eslint-disable-next-line no-shadow
                const [hoverCCSec, setHoverCCSec] = React.useState(false);
                return (
                  <div className='tdCell icon-btn-group'>
                    {hoverCCSec ? (
                      <OverlayTrigger
                        data-tesetid='overlay-trigger'
                        placement='bottom'
                        overlay={<Tooltip id='com-tooltip'>Comment</Tooltip>}
                      >
                        <Button
                          type='button'
                          data-tesetid='second-save'
                          onClick={() => {
                            dispatch(handleSuccessMessages([]));
                            setCorrLinkId(cellInfo && cellInfo.data.corrLinkId);
                            setLinkTableName('DRUG_AUDIT');
                            setShowComments(true);
                          }}
                          tabIndex={'0'}
                          onKeyDown={(e) => {
                            // Handle Enter and Space key events
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault(); // Prevents the default space scrolling behavior
                              dispatch(handleSuccessMessages([]));
                              setCorrLinkId(
                                cellInfo && cellInfo.data.corrLinkId
                              );
                              setLinkTableName('DRUG_AUDIT');
                              setShowComments(true);
                            }
                          }}
                          onMouseOver={() => {
                            setHoverCCSec(true);
                          }}
                          onMouseOut={() => {
                            setHoverCCSec(false);
                          }}
                          className={`th-ic comment-ic ${
                            parseInt(cellInfo.data.ccCommentsExist) === 1
                              ? 'frr-enabled-comment-btn'
                              : 'frr-disabled-comment-btn'
                          }`}
                          variant='text'
                        >
                          {parseInt(cellInfo.data.ccCommentsExist) === 1 ? (
                            <img
                              aria-label='comment'
                              src={CommentVisibleIcon}
                            />
                          ) : (
                            <img aria-label='comment' src={CommentIcon} />
                          )}
                        </Button>
                      </OverlayTrigger>
                    ) : (
                      <Button
                        type='button'
                        onClick={() => {
                          dispatch(handleSuccessMessages([]));
                          setCorrLinkId(cellInfo && cellInfo.data.corrLinkId);
                          setLinkTableName('DRUG_AUDIT');
                          setShowComments(true);
                        }}
                        tabIndex={'0'}
                        onKeyDown={(e) => {
                          // Handle Enter and Space key events
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault(); // Prevents the default space scrolling behavior
                            dispatch(handleSuccessMessages([]));
                            setCorrLinkId(cellInfo && cellInfo.data.corrLinkId);
                            setLinkTableName('DRUG_AUDIT');
                            setShowComments(true);
                          }
                        }}
                        onMouseOver={() => {
                          setHoverCCSec(true);
                        }}
                        onMouseOut={() => {
                          setHoverCCSec(false);
                        }}
                        className={`th-ic comment-ic ${
                          parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1
                            ? 'frr-enabled-comment-btn'
                            : 'frr-disabled-comment-btn'
                        }`}
                        variant='text'
                      >
                        {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                        1 ? (
                          <img aria-label='comment' src={CommentVisibleIcon} />
                        ) : (
                          <img aria-label='comment' src={CommentIcon} />
                        )}
                      </Button>
                    )}
                  </div>
                );
              },
              CheckBoxCellRender: (cellInfo) => {
                return (
                  <>
                    <div className='tbl-checkbox frr-checkbox-no-label'>
                      <FormControlLabel
                        data-testid='checkBox'
                        label='checkbox'
                        id={`checkBox_${cellInfo.rowIndex}`}
                        control={<Checkbox color='primary' />}
                        disabled={isReadOnly || !hasAccessbyRole}
                        onClick={(e) => {
                          if (e.target.checked !== undefined) {
                            if (hasAccessbyRole) {
                              dispatch(handleSuccessMessages([]));
                              const checkedVal = e.target.checked ? 1 : 0;
                              cellInfo.node.setDataValue(
                                cellInfo.column.colId,
                                checkedVal
                              );
                              setSelectedRowData(cellInfo.data);
                              if (cellInfo.api) {
                                cellInfo.api.refreshCells({
                                  force: cellInfo.data,
                                });
                              }
                              dispatch(dispatchSaveUpdate(false));
                            }
                          }
                        }}
                        checked={parseInt(cellInfo.value, [0, 1]) === 1}
                        value={parseInt(cellInfo.value, [0, 1]) === 1}
                      />
                    </div>
                  </>
                );
              },
              NDCCellRender: (cellInfo) => {
                const [hoverUnder, setHoverUnder] = React.useState(false);
                const goToNdcDetails = async () => {
                  const response = await getNDCDetails([
                    {
                      ndc: cellInfo.data.ndc,
                      drugName: cellInfo.data.drugName,
                    },
                  ]);
                  if (response) {
                    dispatch(setNDCErrorPopupMessage(null));
                    dispatch(setCurrentNDCDetailsIndex(1));
                    dispatch(setCurrentNDCDetailsSelected(response[0]));
                    dispatch(
                      setNDCDetails([
                        {
                          ndc: cellInfo.data.ndc,
                          drugName: cellInfo.data.drugName,
                        },
                      ])
                    );
                    redirectURLLink(
                      '/ndc-details',
                      'NDC Details',
                      history,
                      dispatch
                    );
                  }
                };
                return (
                  <div
                    className={
                      hoverUnder ? 'frr-text-decoration-underline' : ''
                    }
                  >
                    <Link
                      to='#'
                      role='button'
                      onClick={() => goToNdcDetails()}
                      onMouseOver={() => {
                        setHoverUnder(true);
                      }}
                      onMouseOut={() => {
                        setHoverUnder(false);
                      }}
                    >
                      {cellInfo && cellInfo?.data?.ndc}
                    </Link>
                  </div>
                );
              },
              DrugNameRenderer: (cellInfo) => {
                if (
                  cellInfo.value !== null &&
                  cellInfo.value !== '' &&
                  cellInfo.value.length > 20
                ) {
                  return (
                    <OverlayTrigger
                      placement='bottom'
                      overlay={
                        <Tooltip id='labeler-tooltip'>
                          {cellInfo.data.drugName}
                        </Tooltip>
                      }
                    >
                      <div>
                        {cellInfo.data.drugName &&
                          cellInfo.data.drugName.substring(0, 20) + '...'}
                      </div>
                    </OverlayTrigger>
                  );
                } else {
                  return <div>{cellInfo.value}</div>;
                }
              },
              DiscrepancyRenderer: (cellInfo) => {
                if (
                  cellInfo.value !== null &&
                  cellInfo.value !== '' &&
                  cellInfo.value.length > 20
                ) {
                  return (
                    <OverlayTrigger
                      placement='bottom'
                      overlay={
                        <Tooltip id='labeler-tooltip'>
                          {cellInfo.data.discrepancyTypeLongDesc}
                        </Tooltip>
                      }
                    >
                      <div>
                        {cellInfo.data.discrepancyTypeLongDesc &&
                          cellInfo.data.discrepancyTypeLongDesc.substring(
                            0,
                            20
                          ) + '...'}
                      </div>
                    </OverlayTrigger>
                  );
                } else {
                  return <div>{cellInfo.value}</div>;
                }
              },
            }}
          />
        </div>
        <div className='frr-setposition-Clear-unClear'>
          <FormControlLabel
            className='ml-0'
            data-testid='checked_iac'
            control={<Checkbox color='primary' className='mr-2' />}
            label='Cleared'
            disabled={isReadOnly}
            value={fetchState?.clearedIndex}
            checked={fetchState?.clearedIndex}
            onChange={(e) =>
              handleOnChangeEvent(e.target.checked, 'clearedIndex')
            }
          />
          <FormControlLabel
            className='ml-0'
            data-testid='checked_iau'
            control={<Checkbox color='primary' className='mr-2' />}
            label='Uncleared'
            disabled={isReadOnly}
            value={fetchState?.unclearedIndex}
            checked={fetchState?.unclearedIndex}
            onChange={(e) =>
              handleOnChangeEvent(e.target.checked, 'unclearedIndex')
            }
          />
        </div>
      </div>
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName={linkTableName}
          keyValue={keyValue}
        />
      )}
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName={linkTableName}
          corrLinkId={corrLinkId}
        />
      ) : null}
    </div>
  );
};

export default CmsRosiDetails;
